module.exports = __webpack_public_path__ + "img/rocket-launch.1b9ef654.svg";